// extracted by mini-css-extract-plugin
export default {"chip":"qXiMLSa7xcBZcxJyMWAr","chipDot":"VpH0xD12NUjy5rgpzWzR","chipAi":"_WRz01hMT6En3Bdd8DRm"};